var $35da740d59af89ba$exports = {};
let $35da740d59af89ba$var$lastFootnote = 0;
const $35da740d59af89ba$var$footnoteMap = new Map(); // href -> nr
for (const a of document.querySelectorAll(`a[href^="http"]`)){
    const href = a.href;
    let footnote = $35da740d59af89ba$var$footnoteMap.get(href);
    if (typeof footnote === "undefined") {
        $35da740d59af89ba$var$lastFootnote = footnote = $35da740d59af89ba$var$lastFootnote + 1;
        $35da740d59af89ba$var$footnoteMap.set(href, footnote);
    }
// a.dataset.footnote = String(footnote);
} /*
const footnoteContainer = document.createElement("template");
footnoteContainer.innerHTML = `<section class="footnotes">
  <h2>Links</h2>
  <ul>
    ${Array.from(
      footnoteMap,
      ([href, id]) =>
        `<li><sup>[${id}]</sup> <a href="${href}">${href}</a></li>`
    ).join("")}
  </ul>
</section>`;

document.querySelector("main").append(footnoteContainer.content);
*/ 


//# sourceMappingURL=index.13c42d32.js.map
